import script from "./standardInWarehouse.vue?vue&type=script&setup=true&lang=js"
export * from "./standardInWarehouse.vue?vue&type=script&setup=true&lang=js"

import "./standardInWarehouse.vue?vue&type=style&index=0&id=1e44e6ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e44e6ba"]])

export default __exports__